import { CheckBoxItem } from '../util/checkBox';
import { EntryField } from '../util/common/entryField';
import { RadioGroup } from '../util/radioGroup';
import { TextField } from '../util/textFIeld';
import { LOANER_CAR_USE } from '@/consts/bodyAndPaint';

interface EntryLoanerCarFieldProps {
  loanerCarInfo: {
    state: {
      loanerCarSelect: number;
      carRequestText: string;
    };
    setState: {
      loanerCarSelect: (select: number) => void;
      carRequestText: (text: string) => void;
    };
    list: {
      loanerCarSelect: string[];
    };
    error: { carRequestText: string };
  };
  check: boolean;
  onChangeCheck: () => void;
}
export const EntryLoanerCarField = ({
  loanerCarInfo: {
    state: {
      loanerCarSelect: loanerCarSelectState,
      carRequestText: carRequestTextState,
    },
    setState: {
      loanerCarSelect: setLoanerCarSelect,
      carRequestText: setCarRequestText,
    },
    list: { loanerCarSelect: loanerCarSelectList },
    error: { carRequestText: carRequestTextError },
  },
  check,
  onChangeCheck,
}: EntryLoanerCarFieldProps) => {
  const ApproveCheckField = () => {
    const text =
      '代車の状況によってご希望のお車がご用意できない場合がございます。あらかじめご承知おきください。';
    return (
      <div className={'loaner-car-approve'}>
        <div className={'loaner-car-approve-message'}>
          <span>{text}</span>
        </div>
        <div className={'loaner-car-approve-check'}>
          <CheckBoxItem
            name={'loaner-car-approve-check'}
            onChange={onChangeCheck}
            check={check}
            label={'内容を確認し、承諾する'}
          />
        </div>
      </div>
    );
  };
  return (
    <div className={'entry-loaner-car-field'}>
      <EntryField label={'代車を利用しますか？'} required={true}>
        <RadioGroup
          groupName={'loaner_car'}
          list={loanerCarSelectList}
          value={loanerCarSelectState}
          onChange={setLoanerCarSelect}
        />
      </EntryField>
      {loanerCarSelectState === LOANER_CAR_USE.YES_USE.value && (
        <EntryField label={'代車に関するご希望はありますか？'} required={true}>
          <TextField
            value={carRequestTextState}
            onChange={setCarRequestText}
            pattern={carRequestTextError}
            placeholder={''}
          />
        </EntryField>
      )}
      <EntryField label={'確認事項'} required={true}>
        <ApproveCheckField />
      </EntryField>
    </div>
  );
};
